import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {useLocation, useParams, useNavigate} from "react-router-dom";
import {RequestStatus} from "../../utils/Enums";
import {
    deleteSMSSender,
    getCurrentSMSSender,
    resetDeleteSMSSenderStatus,
} from "../../store/reducers/SMSSendersSlice";
import Breadcrumbs from "../common/Breadcrumbs";
import {LoggedInView} from "../common/LoggedInView";
import {BreadcrumbLink} from "../../models/BreadcrumbLink";

interface DeleteSMSSenderScreenProps {
}

export const DeleteSMSSenderScreen: React.FC<DeleteSMSSenderScreenProps> = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const SMSSendersState = useAppSelector(
        (state) => state.SMSSenders
    );
    const requestStatus: RequestStatus =
        SMSSendersState.deleteSMSSenderStatus;

    const {id} = useParams();

    const breadcrumbLinks: BreadcrumbLink[] = [
        {text: "SMS saatjad", url: "/sms-senders"},
        {text: "SMS saatja kustutamine", url: `/sms-senders/${id}/delete`,},
    ];

    useEffect(() => {
        dispatch(resetDeleteSMSSenderStatus());
    }, [location]);

    const handleConfirm = () => {
        dispatch(deleteSMSSender({id}));
    };

    const handleCancel = () => {
        navigate(-1);
    };

    useEffect(() => {
        dispatch(getCurrentSMSSender({id}));
    }, [id]);

    const showSuccess = () => {
        return (
            <div className="message msg-ok">
                <div>
                    <h2>SMSi saatja kustutatud</h2>
                </div>
            </div>
        );
    };

    const showConfirm = () => {
        return (
            <div className="message" style={{textAlign: "center"}}>
                <div>
                    <h2>
                        Oled kindel, et soovid saatja{" "}
                        <em>{SMSSendersState?.currentSMSSender?.name ?? ''}</em>{" "}
                        kustutada?
                    </h2>
                    <p>
                        <form method="post" id="delete_form" name="delete_form">
                            <input type="hidden" name="yes" value="yes"/>
                            <button type="button" onClick={handleConfirm}>
                                <span>
                                    <strong>Jah</strong>
                                </span>
                            </button>
                            <button type="button" onClick={handleCancel}>
                                Ei
                            </button>
                        </form>
                    </p>
                </div>
            </div>
        );
    };

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks}/>
            {requestStatus === RequestStatus.Success && showSuccess()}
            {requestStatus !== RequestStatus.Success && showConfirm()}
        </LoggedInView>
    );
};